/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getDiaglabAssistants } from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getImageTests } from 'app/entities/image-tests/image-tests.reducer';
import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getLabPrescriptions } from 'app/entities/lab-prescription/lab-prescription.reducer';
import { getEntities as getTreatmentPlans } from 'app/entities/treatment-plan/treatment-plan.reducer';
import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './radiology-study.reducer';

export const RadiologyStudyUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const appointments = useAppSelector(state => state.appointments.entities);
  const diaglabAssistants = useAppSelector(state => state.diaglabAssistant.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const imageTests = useAppSelector(state => state.imageTests.entities);
  const prescriptions = useAppSelector(state => state.prescription.entities);
  const labPrescriptions = useAppSelector(state => state.labPrescription.entities);
  const treatmentPlans = useAppSelector(state => state.treatmentPlan.entities);
  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const radiologyStudyEntity = useAppSelector(state => state.radiologyStudy.entity);
  const loading = useAppSelector(state => state.radiologyStudy.loading);
  const updating = useAppSelector(state => state.radiologyStudy.updating);
  const updateSuccess = useAppSelector(state => state.radiologyStudy.updateSuccess);
  const patientTypeValues = Object.keys(PatientType);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/radiology-study${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
    dispatch(getAppointments({}));
    dispatch(getDiaglabAssistants({}));
    dispatch(getGlucoUsers({}));
    dispatch(getDoctors({}));
    dispatch(getImageTests({}));
    dispatch(getPrescriptions({}));
    dispatch(getLabPrescriptions({}));
    dispatch(getTreatmentPlans({}));
    dispatch(getPatientProcedures({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.dateActivated !== undefined && typeof values.dateActivated !== 'number') {
      values.dateActivated = Number(values.dateActivated);
    }
    if (values.autoExpireDate !== undefined && typeof values.autoExpireDate !== 'number') {
      values.autoExpireDate = Number(values.autoExpireDate);
    }
    if (values.dateStopped !== undefined && typeof values.dateStopped !== 'number') {
      values.dateStopped = Number(values.dateStopped);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.dateVoided !== undefined && typeof values.dateVoided !== 'number') {
      values.dateVoided = Number(values.dateVoided);
    }
    if (values.scheduledDate !== undefined && typeof values.scheduledDate !== 'number') {
      values.scheduledDate = Number(values.scheduledDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...radiologyStudyEntity,
      ...values,
      servedBy: diagLabs.find(it => it.id.toString() === values.servedBy?.toString()),
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      otcBy: diaglabAssistants.find(it => it.id.toString() === values.otcBy?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      orderedBy: doctors.find(it => it.id.toString() === values.orderedBy?.toString()),
      imageTests: imageTests.find(it => it.id.toString() === values.imageTests?.toString()),
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      labPrescription: labPrescriptions.find(it => it.id.toString() === values.labPrescription?.toString()),
      treatmentPlan: treatmentPlans.find(it => it.id.toString() === values.treatmentPlan?.toString()),
      procedure: patientProcedures.find(it => it.id.toString() === values.procedure?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientType: 'OP',
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...radiologyStudyEntity,
          servedBy: radiologyStudyEntity?.servedBy?.id,
          appointment: radiologyStudyEntity?.appointment?.id,
          otcBy: radiologyStudyEntity?.otcBy?.id,
          patient: radiologyStudyEntity?.patient?.id,
          orderedBy: radiologyStudyEntity?.orderedBy?.id,
          imageTests: radiologyStudyEntity?.imageTests?.id,
          prescription: radiologyStudyEntity?.prescription?.id,
          labPrescription: radiologyStudyEntity?.labPrescription?.id,
          treatmentPlan: radiologyStudyEntity?.treatmentPlan?.id,
          procedure: radiologyStudyEntity?.procedure?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.radiologyStudy.home.createOrEditLabel" data-cy="RadiologyStudyCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.home.createOrEditLabel">Create or edit a RadiologyStudy</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="radiology-study-id"
                  label={translate('tinyMedicRestApp.radiologyStudy.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.instructions')}
                id="radiology-study-instructions"
                name="instructions"
                data-cy="instructions"
                type="text"
                validate={{
                  maxLength: { value: 300, message: translate('entity.validation.maxlength', { max: 300 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.dateActivated')}
                id="radiology-study-dateActivated"
                name="dateActivated"
                data-cy="dateActivated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.autoExpireDate')}
                id="radiology-study-autoExpireDate"
                name="autoExpireDate"
                data-cy="autoExpireDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.dateStopped')}
                id="radiology-study-dateStopped"
                name="dateStopped"
                data-cy="dateStopped"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.reason')}
                id="radiology-study-reason"
                name="reason"
                data-cy="reason"
                type="text"
                validate={{
                  maxLength: { value: 300, message: translate('entity.validation.maxlength', { max: 300 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.microSec')}
                id="radiology-study-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.voided')}
                id="radiology-study-voided"
                name="voided"
                data-cy="voided"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.voidedBy')}
                id="radiology-study-voidedBy"
                name="voidedBy"
                data-cy="voidedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.dateVoided')}
                id="radiology-study-dateVoided"
                name="dateVoided"
                data-cy="dateVoided"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.voidReason')}
                id="radiology-study-voidReason"
                name="voidReason"
                data-cy="voidReason"
                type="text"
                validate={{
                  maxLength: { value: 300, message: translate('entity.validation.maxlength', { max: 300 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.urgency')}
                id="radiology-study-urgency"
                name="urgency"
                data-cy="urgency"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.orderStatus')}
                id="radiology-study-orderStatus"
                name="orderStatus"
                data-cy="orderStatus"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.scheduledDate')}
                id="radiology-study-scheduledDate"
                name="scheduledDate"
                data-cy="scheduledDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.timestampentry')}
                id="radiology-study-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.lastupdated')}
                id="radiology-study-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.cursor')}
                id="radiology-study-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.active')}
                id="radiology-study-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.otc')}
                id="radiology-study-otc"
                name="otc"
                data-cy="otc"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.patientType')}
                id="radiology-study-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.exposed')}
                id="radiology-study-exposed"
                name="exposed"
                data-cy="exposed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.addedByType')}
                id="radiology-study-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.addedByID')}
                id="radiology-study-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.modifiedByType')}
                id="radiology-study-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyStudy.modifiedByID')}
                id="radiology-study-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
              />
              <ValidatedField
                id="radiology-study-servedBy"
                name="servedBy"
                data-cy="servedBy"
                label={translate('tinyMedicRestApp.radiologyStudy.servedBy')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.radiologyStudy.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-otcBy"
                name="otcBy"
                data-cy="otcBy"
                label={translate('tinyMedicRestApp.radiologyStudy.otcBy')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabAssistants
                  ? diaglabAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.radiologyStudy.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-orderedBy"
                name="orderedBy"
                data-cy="orderedBy"
                label={translate('tinyMedicRestApp.radiologyStudy.orderedBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-imageTests"
                name="imageTests"
                data-cy="imageTests"
                label={translate('tinyMedicRestApp.radiologyStudy.imageTests')}
                type="select"
              >
                <option value="" key="0" />
                {imageTests
                  ? imageTests.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.radiologyStudy.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-labPrescription"
                name="labPrescription"
                data-cy="labPrescription"
                label={translate('tinyMedicRestApp.radiologyStudy.labPrescription')}
                type="select"
              >
                <option value="" key="0" />
                {labPrescriptions
                  ? labPrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-treatmentPlan"
                name="treatmentPlan"
                data-cy="treatmentPlan"
                label={translate('tinyMedicRestApp.radiologyStudy.treatmentPlan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentPlans
                  ? treatmentPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-study-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.radiologyStudy.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/radiology-study" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RadiologyStudyUpdate;
